// extracted by mini-css-extract-plugin
module.exports = {"icon":"_2HswSE","spin":"_3T7l6e","icon-spin":"_34CH3L","adjustCenter":"_140MFx","offsetRight":"_1i8aZF","offsetLeft":"_3fThY-"};